import TopBar from "@/components/Topbar";
import { DriveContext } from "@/store/DriveContext";
import { useContext, useEffect, useState } from "react";
import MemoryMainContent from "@/components/MemoryMainContent";

interface IOppDetails {
  userId: string;
  username: string;
}

function Memory() {
  const [loader, setLoader] = useState<boolean>(true);
  const { user } = useContext(DriveContext)!;
  const [question, setQuestion] = useState<number[][] | null>(null);
  const [ws, setWs] = useState<null | WebSocket>(null);
  const [score, setScore] = useState<number>(0);
  const [oppScore, setOppScore] = useState<number>(0);
  const [oppDetails, setOppDetails] = useState<IOppDetails | null>(null);
  const [oppRating, setOppRating] = useState<number>(0);
  
  useEffect(() => {
    const wsUrl = "wss://matrix-sggb.onrender.com";
    const socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      console.log("Server connected");
      socket.send(
        JSON.stringify({
          type: "play",
          rating: user?.rating || 0,
          gameName: "memory",
          userId: user?.userId,
          username: user?.username,
        }),
      );
    };

    socket.onmessage = (msg) => {
      const parsed = JSON.parse(msg.data);
      console.log("In the memory component", parsed);
      if (parsed.success === false) {
        alert(parsed.message);
        return;
      }

      if (parsed.questions) {
        console.log("Memory questions ", parsed.questions);
        setQuestion(parsed.questions);
        return;
      }

      if (parsed.success) {
        if (parsed.message === "Waiting for another player to join") {
          setLoader(true);
          return;
        } else if (parsed.message === "Match Found, game starting") {
          setOppDetails({
            userId: parsed.oppDetails.userId,
            username: parsed.oppDetails.username,
          });
          setOppRating(parsed.oppRating);
          setLoader(false);
        }
      }

      if (parsed.yourScore !== undefined && parsed.oppScore !== undefined) {
        setScore(parsed.yourScore);
        setOppScore(parsed.oppScore);
      }
    };

    setWs(socket);

    return () => {
      socket.close();
    }
  }, [user]);

  return (
    <div className="h-[100dvh] bg-[#0a0a12] flex flex-col overflow-hidden relative">
      <TopBar />
      
      <div className="flex-1 flex flex-col relative z-10 overflow-hidden">
        {loader ? (
          <div className="flex-1 flex flex-col items-center justify-center gap-4 px-6 text-center">
            {/* Custom glowing spinner for dark theme match */}
            <div className="w-12 h-12 border-[3px] border-violet-500/30 border-t-violet-400 rounded-full animate-spin shadow-[0_0_15px_rgba(139,92,246,0.3)]" />
            
            <div className="mt-2">
              <h2 className="text-xl sm:text-2xl font-bold bg-gradient-to-br from-violet-300 to-indigo-100 bg-clip-text text-transparent">Matchmaking Area</h2>
              <p className="text-xs sm:text-[13px] text-gray-500 mt-1 uppercase tracking-widest font-semibold">Waiting for a worthy opponent...</p>
            </div>
          </div>
        ) : (
          <MemoryMainContent 
            questions={question} 
            websocket={ws}
            rating={user?.rating || 0}
            score={score}
            oppScore={oppScore}
            setScore={setScore}
            setOppScore={setOppScore}
            oppRating={oppRating}
            oppPlayerDetails={oppDetails}
          />
        )}
      </div>
    </div>
  );
}

export default Memory;
